import { AccountStatus, IAccount } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorAccountWithdrawalReady = (account: IAccount) =>
  (account.status == AccountStatus.Active ||
    account.status === AccountStatus.Pending) &&
  account.canBeUsedFor?.payouts;
